import Vue from 'vue'
import Vuex from 'vuex'
import User from './user.js'
import Admin from './admin.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user: User,
    admin: Admin
  }
})
